/// <amd-module name="VSSUI/Components/TooltipHost/index" />
export * from "./TooltipHost";
